( function () {
    'use strict';
    espresso.ecom.updatePrice = function ( jProductForm ) {
        var jProductPrice = jProductForm.find( '.js-e-price' );
        if ( jProductForm.is( '.js-e-variant-form ' ) === true ) {
            var productId = jProductForm.find( '[name = "ProductID"]' ).val(),
                variantId = jProductForm.find( '[name = "VariantID"]' ).val();
            //console.log( productId, variantId );
            jProductPrice.data( 'price', espresso.ecom.variants.combos[ productId ][ variantId ].ProductPrice );
        }
        var basePrice = jQuery.trim( jProductPrice.data( 'price' ) ),
            displayPrice = co3.util.formatNumberToJavascript( basePrice );
        if ( jProductForm.is( '.js-e-configurator-form ' ) === true ) {
            jProductForm.find( '.control-group input[type="radio"][name^="PRODITEM"]:checked' ).each( function () {
                displayPrice += co3.util.formatNumberToJavascript( jQuery.trim( jQuery( this ).data( 'price' ) ) );
            } );
        }
        jProductPrice.text( co3.util.formatNumber( displayPrice ) );
        //console.log( co3.util.formatNumber( displayPrice ) );
    };
}() );
